module.exports = __webpack_public_path__ + "img/quick_preclass.3a9b30d2.png";